/**
 * FontAwesome icon name for a PrimeVue DataTable column header's sort state: `sort-up` for
 * ascending (1), `sort-down` for descending (-1), plain `sort` when the column is unsorted.
 */
export const getSortIcon = (sortOrder: number | null | undefined): string => {
  if (sortOrder === 1) return "sort-up";
  if (sortOrder === -1) return "sort-down";
  return "sort";
};
